import { getTariffUnitPriceCents, type ItemTariff } from '@src/domains/tariffs/core/tariffReaders';

export const getTariffTotalPrice = (tariffs: ItemTariff[]): number =>
  tariffs.reduce((total, tariff) => total + tariff.quantity * getTariffUnitPriceCents(tariff), 0);
